import React from "react";
import { Grow, Table, TableHead, TableBody, TableCell, TableRow, Grid, TableContainer, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../style.css";

export default function BreakdownPlaceAndDetailTable(props) {
    const { t } = useTranslation("translation");

    return (
        <Grid container item md={12}>
            <Grid item xs={10} sm={6} md={8}>
                <div className="masterDataTable">
                    <Table aria-label="simple table">
                        <TableHead sx={{position: "sticky", top: 0}}>
                            <TableRow>
                                <TableCell align="center">{t("Line")} </TableCell>
                                <TableCell align="center">{t("BreakdownGroupCode")} </TableCell>
                                <TableCell align="center">{t("BreakdownGroupName")} </TableCell>
                                <TableCell align="center">{t("BreakdownPlaceName")} </TableCell>
                                <TableCell align="center">{t("BreakdownPlaceCode")} </TableCell>
                                <TableCell align="center">{t("BreakdownDetailName")} </TableCell>
                                <TableCell align="center">{t("BreakdownDetailCode")} </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.breakdownExcel.map((row, index) => (
                                <TableRow style={{ background: row.hasWarning ? "#FF9089" : "aliceblue" }}>
                                    <TableCell className="fontColor" align="center">{index + 2}</TableCell>
                                    <TableCell className="fontColor" align="center">{row.groupCode}</TableCell>
                                    <TableCell className="fontColor" align="center">{row.groupDefinition}</TableCell>
                                    <TableCell className="fontColor" align="center">{row.breakdownLocationDefinition}</TableCell>
                                    <TableCell className="fontColor" align="center">{row.breakdownLocationCode}</TableCell>
                                    <TableCell className="fontColor" align="center">{row.breakdownDetailDefinition}</TableCell>
                                    <TableCell className="fontColor" align="center">{row.breakdownDetailCode}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </Grid>
            <Grid container xs={1} sm={3} md={4}>
                {props.warnings.length > 0 && props.breakdownExcel.length > 0 ? (
                    <>
                        <Grid item md={1}></Grid>
                        <Grid item md={11}>
                            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                                <TableContainer component={Paper} className="warningTable">
                                    <Table sx={{ minWidth: 200 }} aria-label="simple table">
                                        <TableHead sx={{position: "sticky", top: 0}}>
                                            <TableRow>
                                                <TableCell className="lineWidth" align="center">{t("Line")}</TableCell>
                                                <TableCell align="center">{t("Warnings")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {props.warnings.map((row) => (
                                                <TableRow>
                                                    <TableCell sx={{maxWidth: 200}} className="fontColor" align="center">{row.rowNumber}</TableCell>
                                                    <TableCell size="small" className="fontColor" align="center">{row.message}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grow>
                        </Grid>
                    </>
                ) : null}
            </Grid>{" "}
        </Grid>
    );
}
